import Select, { ActionMeta, GroupBase, OptionsOrGroups } from "react-select";
import { useEffect, useState } from "react"

export type MySelectProps = {
  className?: string | undefined
  options?: OptionsOrGroups<any, GroupBase<any>>
  value: any
  onChange?: ((newValue: any, actionMeta: ActionMeta<any>) => void) | undefined
}
function MySelect(props: MySelectProps) {


  return (
    <Select
      styles={{
        control: (base) => ({
          ...base,
          backgroundColor: '#546E70',
          borderRadius: '20px',
          borderWidth: 1.5,
          borderColor: 'white',
          boxShadow: 'none',
          fontSize:18,
          '&:hover': {
            borderColor: '#98B8DB'
          }
        }),
        singleValue: (base) => ({
          ...base,
          color: 'white'
        }),
        indicatorSeparator: () => ({
          display: 'none'
        }),
        dropdownIndicator: (base) => ({
          ...base,
          color: 'white',
          '&:hover': {
            color: 'white'
          }
        })
      }}
      value={props.value}
      options={props.options}
      onChange={props.onChange}
      className={props.className}
    />
  );
}

export default MySelect;
